import { useState } from "react";
import { Card } from "../../components/ui/Card";
import { Button } from "../../components/ui/Button";
import { Input } from "../../components/ui/Input";
import { useSystemTemplates, useUpsertSystemTemplate } from "../../features/superadmin/api";

const EVENT_KEYS = [
  "invite_user",
  "invite_superadmin",
  "password_reset",
  "welcome_user",
  "lead_assigned",
] as const;

export default function SuperadminSystemTemplatesPage() {
  const { data, isLoading } = useSystemTemplates();
  const upsert = useUpsertSystemTemplate();
  const [edits, setEdits] = useState<Record<string, { whatmailTemplateId: string; subjectOverride: string; isActive: boolean }>>({});

  const current = (key: string) => {
    const t = data?.templates.find((x) => x.key === key);
    return edits[key] ?? {
      whatmailTemplateId: t?.whatmailTemplateId ?? "",
      subjectOverride: t?.subjectOverride ?? "",
      isActive: t?.isActive ?? true,
    };
  };

  return (
    <Card
      title="System templates"
      subtitle="Whatmail template per transactional event. Missing rows are silently skipped at send time."
    >
      {isLoading ? <div className="skeleton-rows">Loading…</div> : (
        <div className="form-stack">
          {EVENT_KEYS.map((key) => {
            const c = current(key);
            return (
              <div key={key} className="template-row">
                <div className="template-key"><code>{key}</code></div>
                <Input
                  label="Whatmail template ID"
                  value={c.whatmailTemplateId}
                  onChange={(e) => setEdits({ ...edits, [key]: { ...c, whatmailTemplateId: e.target.value } })}
                />
                <Input
                  label="Subject override (optional)"
                  value={c.subjectOverride}
                  onChange={(e) => setEdits({ ...edits, [key]: { ...c, subjectOverride: e.target.value } })}
                />
                <label className="toggle">
                  <input
                    type="checkbox"
                    checked={c.isActive}
                    onChange={(e) => setEdits({ ...edits, [key]: { ...c, isActive: e.target.checked } })}
                  />
                  <span>{c.isActive ? "active" : "inactive"}</span>
                </label>
                <Button
                  type="button"
                  variant="secondary"
                  disabled={!c.whatmailTemplateId || upsert.isPending}
                  onClick={() =>
                    upsert.mutate({
                      key,
                      whatmailTemplateId: c.whatmailTemplateId,
                      ...(c.subjectOverride ? { subjectOverride: c.subjectOverride } : {}),
                      isActive: c.isActive,
                    })
                  }
                >
                  Save
                </Button>
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
}
